export default __webpack_public_path__ + "static/media/qr-code-scan-1.83cac55a.png";